import { render, staticRenderFns } from "./InsurancesPlanDetailsDelete.vue?vue&type=template&id=00853a09&scoped=true&"
import script from "./InsurancesPlanDetailsDelete.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanDetailsDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00853a09",
  null
  
)

export default component.exports